import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import type { ColumnDef } from "@tanstack/react-table";
import type { Proforma } from "@/lib/proforma.api";
import { Button } from "@/components/ui/button";
import { formatDate, formatMoney } from "./proforma-formatters";
import { getProformaSummary, getProformaTotal } from "./proforma-calculations";
import { ProformaStatusBadge } from "./components/ProformaStatusBadge";

export function createProformaColumns(
  onQuickView: (proforma: Proforma) => void,
): ColumnDef<Proforma, any>[] {
  return [
    {
      id: "number",
      header: "Proforma",
      cell: ({ row }) => (
        <div>
          <Link
            to={`/proformas/${row.original.id}`}
            className="text-[12px] font-medium text-brand-gold-dark hover:underline"
            onClick={(event) => event.stopPropagation()}
          >
            {row.original.number}
          </Link>
          <p className="mt-0.5 text-[10.5px] text-muted-foreground">
            {getProformaSummary(row.original)}
          </p>
        </div>
      ),
    },
    {
      id: "party",
      header: "Client",
      cell: ({ row }) => (
        <div>
          <p className="text-[12px] font-medium text-body">
            {row.original.partySnapshot?.fullName ?? "-"}
          </p>
          <p className="mt-0.5 text-[10.5px] text-muted-foreground">
            {row.original.partySnapshot?.phone ??
              row.original.partySnapshot?.email ??
              "Contact non renseigné"}
          </p>
        </div>
      ),
    },
    {
      id: "total",
      header: "Total",
      meta: { align: "right" },
      cell: ({ row }) => (
        <span className="text-[12px] font-semibold tabular-nums text-foreground">
          {formatMoney(getProformaTotal(row.original))}
        </span>
      ),
    },
    {
      id: "dates",
      header: "Dates",
      cell: ({ row }) => (
        <div className="text-[12px] text-muted-foreground">
          <p>Créée: {formatDate(row.original.createdAt)}</p>
          <p>Expire: {formatDate(row.original.expiresAt)}</p>
        </div>
      ),
    },
    {
      accessorKey: "status",
      header: "Statut",
      cell: ({ row }) => <ProformaStatusBadge status={row.original.status} />,
    },
    {
      id: "actions",
      header: "",
      meta: { align: "right" },
      cell: ({ row }) => (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          title="Aperçu rapide"
          onClick={(event) => {
            event.stopPropagation();
            onQuickView(row.original);
          }}
        >
          <Eye size={13} />
        </Button>
      ),
    },
  ];
}
